<template>
  <specialty-accordion-input
      v-model="value"
      @input="$emit('input', $event)"
      @expand="$emit('expand' , $event)"
      :specialty-id="specialtyId"
      :lang="$store.state.wsu_structure.selectedLang"
      title="wsu_structure.specialty.alumnis.title"
      type="alumni"
      :blank-element="blankElement"
  >

    <template #item="{item}">
      <img :src="item.img"
             height="52"
             width="52"
             style="border-radius: 50%;"
             alt=""
             class="mr-4 my-2"
      />
      <div class="py-3">
        <h5 class="wsDARKER shorten-text">{{ item.name }} <span class="font-weight-regular"> - {{ item.position }} </span></h5>
        <h5 class="font-weight-regular shorten-text">{{ item.short_description }}</h5>
      </div>
    </template>
    <template #editor="{entityData}">
      <h5 class="font-weight-regular wsACCENT mb-2">
        {{ $t('wsu_structure.specialty.alumnis.img') }}
      </h5>
      <image-param-picker
          v-model="entityData.img"
          no-border
          class="mb-5"
          disable-portal
      />
      <!-- Name-->
      <ws-text-field
          :label="$t('HumanName')"
          :placeholder="$t('EnterHumanName')"
          v-model="entityData.name"
          class="mb-5"
      />
      <!-- Position-->
      <ws-text-field
          :label="$t('wsu_structure.specialty.alumnis.position.label')"
          :placeholder="$t('wsu_structure.specialty.alumnis.position.placeholder')"
          v-model="entityData.position"
          class="mb-5"
      />
      <!-- Short Description-->
      <ws-text-field
          :label="$t('wsu_structure.specialty.alumnis.short_description.label')"
          :placeholder="$t('wsu_structure.specialty.alumnis.short_description.placeholder')"
          v-model="entityData.short_description"
          class="mb-5"
          max-chars="300"
          maxlength="300"
          area
      />
      <!-- Full Description -->
      <h5 class="font-weight-regular wsACCENT mb-2">
        {{ $t('courses.description.description.title') }}
      </h5>
      <v-sheet min-height="200" :style="`border : 1px solid ${wsDARKLIGHT}`" class="wsRoundedLight   pb-7">
        <ws-text-editor
            v-model="entityData.description"
            is-public
        />
      </v-sheet>

    </template>


  </specialty-accordion-input>
</template>

<script>
import specialtyAccordionInput from "@modules/wsu_structure/components/description/specialtyAccordionInput.vue";
import imageParamPicker from "@/components/AvalonEditor/UI/imageParamPicker.vue";

export default {
  name: "descriptionSpecialtyEnrollmentCommittee",
  components: {imageParamPicker, specialtyAccordionInput},
  props : {
    value : {
      type : Object,
      default() {
        return {}
      }
    },
    specialtyId : {
      type : String,
    }
  },
  data() {
    return {
      blankElement : {
        name : '',
        position : '',
        short_description : '',
        description : [{ isHtml: true, content: ''}],
        img : ''
      }
    }
  },
  methods : {
    handleClearArrayItem(value , index , key , entityData) {
      if (!value) {
        entityData[key].splice(index,1)
      }
    }
  }
}
</script>



<style scoped>

</style>